import React, { useState, useEffect, useRef  } from 'react';
import { api } from '../../api'; // Make sure the path is correct

const AccessTimeModal = ({ device, onClose, onSubmit, isSubmitting }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    // --- CHANGE 1: Default to Time Zone 0 ---
    const [timeZoneNumber, setTimeZoneNumber] = useState(0); 
    const [schedule, setSchedule] = useState([]);
    const effectRan = useRef(false);

    useEffect(() => {
        if (effectRan.current === false) {
            const fetchSchedule = async () => {
                if (!device) return;
                setIsLoading(true);
                setError(null);
                try {
                    // --- CHANGE 2: Fetch data for Time Zone 0 ---
                    const data = await api.getDeviceAccessTimeZone(device.id, 0); 
                    setTimeZoneNumber(data.timeZoneNumber);
                    setSchedule(data.schedules);
                } catch (err) {
                    setError(err.message);
                } finally {
                    setIsLoading(false);
                }
            };

            fetchSchedule();
        }

        return () => {
            effectRan.current = true;
        };
    }, [device]);

    const handleScheduleChange = (index, field, value) => {
        const newSchedule = [...schedule];
        newSchedule[index][field] = value;
        setSchedule(newSchedule);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const enabledSchedules = schedule
            .filter(day => day.enabled)
            .map(({ day, startTime, endTime }) => ({ day, startTime, endTime }));
        
        onSubmit({ timeZoneNumber, schedules: enabledSchedules });
    };

    const renderContent = () => {
        if (isLoading) {
            return <p>Loading schedule...</p>;
        }
        if (error) {
            return <p style={{ color: 'red' }}>Error: {error}</p>;
        }
        return (
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="form-label" htmlFor="tz-number">
                        Time Zone Rule Number (0-49)
                    </label>
                    {/* --- CHANGE 3: Make the input read-only --- */}
                    <input
                        id="tz-number"
                        type="number"
                        value={timeZoneNumber}
                        readOnly 
                        className="form-input"
                        style={{ maxWidth: '120px', backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                    />
                </div>
                <div className="schedule-container">
                    {schedule.map((day, index) => (
                        <div key={day.day} className={`schedule-row ${!day.enabled ? 'disabled' : ''}`}>
                            <span className="schedule-day-name">{day.name}</span>
                            <div className="schedule-controls">
                                <label className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={day.enabled}
                                        onChange={(e) => handleScheduleChange(index, 'enabled', e.target.checked)}
                                    />
                                    <span className="slider"></span>
                                </label>
                                <div className="time-inputs">
                                    <input
                                        type="time"
                                        value={day.startTime}
                                        disabled={!day.enabled}
                                        onChange={(e) => handleScheduleChange(index, 'startTime', e.target.value)}
                                        className="form-input"
                                    />
                                    <span className="time-separator">to</span>
                                    <input
                                        type="time"
                                        value={day.endTime}
                                        disabled={!day.enabled}
                                        onChange={(e) => handleScheduleChange(index, 'endTime', e.target.value)}
                                        className="form-input"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="modal-actions">
                    <button type="button" onClick={onClose} className="button button-secondary" disabled={isSubmitting}>
                        Cancel
                    </button>
                    <button type="submit" className="button action-button" disabled={isSubmitting}>
                        {isSubmitting ? 'Saving...' : 'Save Schedule'}
                    </button>
                </div>
            </form>
        );
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Access Time Zone for {device.serial_number}</h2>
                {renderContent()}
            </div>
        </div>
    );
};

export default AccessTimeModal;